import { isMosAuthProvider } from '@commons/auth/session';
import { isMosOidcBootstrapPath } from '@commons/auth/constants';

import { getMosAccessToken } from './mosAuth';

const getLegacyAccessToken = () => window.localStorage.getItem('loopbackAccessToken');

/**
 * Resolve the Authorization header value for the active InPulse session.
 * - MOS: `Bearer <MOS access token>`
 * - Legacy: raw LoopBack access token
 * - MOS bootstrap (callback/complete, including leftover LoopBack): Bearer
 * Prefer MOS credentials when a MOS session (or bootstrap) is active.
 * Otherwise keep an explicit caller Authorization (SSO, invite, password-reset).
 */
export const getAuthorizationHeader = async (existingAuthorization) => {
  const mosAccessToken = await getMosAccessToken();

  if (isMosAuthProvider() || isMosOidcBootstrapPath()) {
    if (!mosAccessToken) {
      return undefined;
    }

    return `Bearer ${mosAccessToken}`;
  }

  const legacyToken = getLegacyAccessToken();

  // MOS bootstrap when authProvider is not marked yet and there is no LoopBack token.
  if (mosAccessToken && !legacyToken) {
    return `Bearer ${mosAccessToken}`;
  }

  if (existingAuthorization) {
    return existingAuthorization;
  }

  return legacyToken || undefined;
};
